<template>
  <nav class="fixed bottom-0 left-0 right-0 md:hidden z-40 backdrop-blur-xl border-t shadow-lg mobile-bottom-navigation">
    <div class="flex justify-around items-center h-16">
      <component
        v-for="item in navigationItems"
        :key="item.name"
        :is="item.name === 'messages' ? 'button' : 'router-link'"
        :to="item.name !== 'messages' ? item.to : undefined"
        @click="item.name === 'messages' ? handleMessagesClick() : undefined"
        class="flex flex-col items-center justify-center flex-1 h-full relative"
        :class="{
          'text-brand-accent dark:text-brand-accent-dark': $route.path === item.to,
          'text-gray-500 dark:text-gray-400': $route.path !== item.to
        }"
      >
        <component :is="item.icon" class="w-6 h-6 mb-1" />
        <span class="text-xs font-medium">{{ $t(item.label) }}</span>

        <!-- Active indicator -->
        <div
          v-if="$route.path === item.to"
          class="absolute top-0 left-1/2 transform -translate-x-1/2 w-8 h-0.5 bg-brand-accent dark:bg-brand-accent-dark rounded-full"
        ></div>

        <!-- Badge for messages -->
        <div
          v-if="item.name === 'messages' && unreadCount > 0"
          class="absolute top-1 right-1/4 w-5 h-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center"
        >
          {{ unreadCount > 99 ? '99+' : unreadCount }}
        </div>
      </component>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useMessageRouter } from '@/services/messageRouterService'
import {
  MagnifyingGlassIcon,
  ChatBubbleLeftRightIcon,
  UserIcon,
  StarIcon
} from '@heroicons/vue/24/outline'

// Composables
useAuthStore()
const messageRouter = useMessageRouter()

// Computed properties

// Mock unread count - would come from message store in real app
const unreadCount = computed(() => 0)

// Handle messages click
const handleMessagesClick = async () => {
  await messageRouter.handleBottomNavMessagesClick()
}

// Navigation items
const navigationItems = computed(() => [
  { name: 'discover', to: '/discover', label: 'navigation.discover', icon: MagnifyingGlassIcon },
  { name: 'wish-tree', to: '/wish-tree', label: 'navigation.wishTree', icon: StarIcon },
  { name: 'messages', to: '/messages', label: 'navigation.messages', icon: ChatBubbleLeftRightIcon },
  { name: 'profile', to: '/profile', label: 'navigation.profile', icon: UserIcon }
])
</script>

<style scoped>
.mobile-bottom-navigation {
  padding-bottom: env(safe-area-inset-bottom, 0px);
  color: var(--text-tertiary);
  background: rgba(33, 14, 20, 0.9);
  border-color: var(--border-secondary);
  box-shadow: 0 -12px 30px rgba(0, 0, 0, 0.24);
}
</style>
